import React, { useState, useEffect } from "react";
import Skeleton from '@material-ui/lab/Skeleton';
import Grid from '@material-ui/core/Grid';
import InfoContainer from "./container/InfoContainer";
import ReactImageFallback from "react-image-fallback";
import axios from 'axios';
import { Translation } from 'react-i18next';
import styles from './achievements.module.css';
import { Link } from 'react-router-dom';
import { CDN_URI_BASE, CDN_URI as MAIN_CDN_URI, profileAPI } from '../common/utilities';
import missingAchievementImg from "../images/achievement-missing.png";

import {
    getStaticAchievementsList,
    generatePageURI, 
    pagePaths
} from '../common/utilities';


class AcheivementSkeleton extends React.Component{
    render (){
        return(
            <div className={styles.row}>
                <div className={styles.imgbox}>
                    <Skeleton variant="circle" width="70px" height="70px" />
                </div>
                <div className={styles.text}>
                    <Skeleton height={2} width="80%"/>
                    <Skeleton height={2} width="80%"/>
                </div>
            </div>            
        );
    }
}

export default class Achievements extends React.Component{

	constructor(props){
	    super(props);

	    this.state = {
            allAchievements: null
            ,achievement_total: 0
            ,outputList: []
            ,userAchievements: this.props.userAchievements
            ,userTotal: this.props.userTotal
            ,contentReady: false
        }

        //console.log('totals', this.props.userTotal);        
        //console.log(this.props.userAchievements);
    }

    componentDidUpdate(){

        var _this = this;
        if(this.props.userAchievements && this.props.userTotal && null == this.state.allAchievements){

            //console.log(this.props.userAchievements)

            getStaticAchievementsList(function(data){
                _this.setState({
                    allAchievements: data,
                    achievement_total : data.length,
                });

            })
        }


        if(null !== this.state.allAchievements && null == this.state.userAchievements && !this.state.contentReady){

            //console.log(this.state.allAchievements);
            //console.log(this.state.userAchievements);

            this.setAchievements();
        }
    }

    // display achievements in order of most completed

    setAchievements(){

        /*
        console.log('user');
        console.log(this.state.userAchievements);
        console.log('all');
        console.log(this.state.allAchievements);
        // */
        var CDN_URI = `${MAIN_CDN_URI}imgs/achievement_system/`;

        // profile index page only allows 6
        var maxOutput = 5;

        // the final object is going to be the merge of: (1) static achievement data, and (2) player progress data
        var myAchievements = [];
        for(var i=0; i<this.props.userAchievements.length; i++) {

            if(this.state.allAchievements.find((itmInner) => itmInner.achievementID === this.props.userAchievements[i].MAIN_INDEX)){
                var Ach = this.state.allAchievements.find((itmInner) => itmInner.achievementID === this.props.userAchievements[i].MAIN_INDEX);
                Ach.CURRENT_STAGE = this.props.userAchievements[i].CURRENT_STAGE;
                Ach.TOTAL_STAGE = this.props.userAchievements[i].TOTAL_STAGE

                myAchievements.push(Ach);         
            }
        }


        // for(var i=0; i<this.state.allAchievements.length; i++) {

        //     if(this.props.userAchievements.find((itmInner) => itmInner.MAIN_INDEX === this.state.allAchievements[i].achievementID)){
        //         myAchievements.push({
        //             ...(this.props.userAchievements.find((itmInner) => itmInner.MAIN_INDEX === this.state.allAchievements[i].achievementID)),
        //             ...this.state.allAchievements[i]
        //         });                
        //     }
        // }

        // add an empty achievement to get to maxOutput if necessary
        if(myAchievements.length < maxOutput){

            for(var l=myAchievements.length; l<maxOutput; l++) {

                var randomAch = this.state.allAchievements[l];
                randomAch.CURRENT_STAGE = 0;
                randomAch.TOTAL_STAGE = 1

                myAchievements.push(randomAch);
            }
        }

        var string = [];

        for(var i = 0; i< maxOutput; i++){

            var currentStyle = (myAchievements[i].CURRENT_STAGE) ? styles.row : styles.row + ' ' + styles.noprogress;
            var currentProgress = this.getStageImg(myAchievements[i].CURRENT_STAGE, myAchievements[i].TOTAL_STAGE);

            var imgFile = (myAchievements[i].image_file).replace('_off', '');

            var levelTitle = (currentProgress) ? 'Lvl_' + myAchievements[i].CURRENT_STAGE + '_Name' : null;
            var displayTitle = (myAchievements[i][levelTitle]) ? myAchievements[i][levelTitle] : myAchievements[i].Display_Name;

            var placeholder = 'achievement-missing.png'

            string.push(
                    <div className={currentStyle} key={i}>
                        <div className={styles.imgbox}>
                            <ReactImageFallback
                                src={`${CDN_URI_BASE}web/achievements/${imgFile}`}
                                fallbackImage={missingAchievementImg}
                                alt="achievement"
                            />
                            {currentProgress}
                        </div>
                        <div className={styles.text}>
                            <h5>{displayTitle}</h5>
                            <br />
                            <p>{myAchievements[i].Description}</p>
                        </div>
                    </div>
            );
        }

        this.setState({
            outputList: string
            ,contentReady: true
        });

        //return string;
    }

    getStageImg(current, max){
        var CDN_URI = `${MAIN_CDN_URI}imgs/achievement_system/`;

        var prefix = 'trophy_';
        var stage = null;
        switch(max){
            case 5: stage = 'a'; break;
            case 3: stage = 'b'; break;
            case 1: stage = 'c'; break;
        }

        return (current && max && stage && (current <= max))
                ? <img src={CDN_URI + prefix + stage + current + '.png'} alt="trophy stage" />
                : null;
    }

    /* really only needed for page*/ 
    getUserAchievements(){

        var apilink = profileAPI;
      
        // profile 2 dataset = 'dsAchievmentResult'
        // profile 2 dataset = 'dsAchievmentTotal' -> PlayerCNT, AchievementCNT
      
        var params = {};

        var _this = this;

        params.command = 'achievements';
        params.usn = this.props.usn;
        params.achievement = 0;     // get all
        params.order = 2;           // get by most recently achieved

        var _this = this;
      
        axios.get(apilink, {params: params})
          .then(function(response){
      
            if(response.data){
      
              if(response.data.APIresult && '000' == response.data.APIresult 
              && response.data.p_o_ErrID && '1' == response.data.p_o_ErrID
              && !response.data.p_o_ErrDesc && response.data.dsAchievementResult
              && response.data.APImessage && 'OK' == response.data.APImessage){
      
                console.log('SUCCESS: retrieved user achievements data');
                //console.log(response.data.Achievements);
                //console.log(response.data.Total_Achievements_Count);
                //console.log(response.data.User_Achievements_Count);

                _this.setState({
                    //userAchievements: response.data.Achievements
                    userAchievements: response.data.dsAchievementResult
                });
              }else{
                console.log('FAIL: could not retrieve user achievements due to \'not OK\' repsponse');
                  _this.setState({
                      userAchievements: []
                  });
              }
            }else{
              console.log('FAIL: could not retrieve user achievements');
                _this.setState({
                    userAchievements: []
                });
            }
          });
      }

    render (){

        if(this.state.contentReady){
        //if(this.props.userAchievements && null !== this.state.allAchievements){
            return (
                <Translation>
                {
                (t) =>
                <Grid item>
                    <InfoContainer
                        headerLeft = {<Link to={generatePageURI(pagePaths.ACHIEVEMENTS)}>{t('Achievements')}</Link>}
                        headerRight = {this.props.userTotal.playerCNT+'/' + this.props.userTotal.achievementCNT}
                        //headerRight = {this.props.userTotal.playerCNT+'/'+this.props.userTotal.achievementCNT}
                        footer ={<Link 
                            to={generatePageURI(
                                pagePaths.ACHIEVEMENTS
                            )}
                            >
                                {t('See All Achievements')}
                            </Link>}
                        children = {<div className={styles.achievements}>{this.state.outputList}</div>}
                        />
                </Grid>
                }
                </Translation>
            );
        }else{
            return (
                <Grid item>
                    <InfoContainer
                        headerLeft = {<Link to={generatePageURI(pagePaths.ACHIEVEMENTS)}>Achievements</Link>}
                        footer ={<Link 
                            to={generatePageURI(
                                pagePaths.ACHIEVEMENTS
                            )}
                            >
                                See All Achievements
                            </Link>}
                            children =  {   <div className={styles.achievements}>
                                                <AcheivementSkeleton key="1" />
                                                <AcheivementSkeleton key="2" />
                                                <AcheivementSkeleton key="3" />
                                                <AcheivementSkeleton key="4" />
                                                <AcheivementSkeleton key="5" />
                                            </div>
                                        }
                        />
                </Grid>
            );                
        }
    }
}